// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fnl-title {
  margin: 0px 0 24px 0;
  font-size: 20px;
  color: #2d2d2f;
  letter-spacing: 0.2px;
}

.fnl-row {
  margin-bottom: 10px;
}

.fnl-row .MuiOutlinedInput-root {
  border-radius: 10px;
}

.fnl-fetch-btn {
  border-radius: 10px;
  padding: 11px 18px;
  box-shadow: 0 6px 14px rgba(94, 27, 255, 0.18);
}

.fnl-spinner-row {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #585a63;
  font-size: 0.95rem;
  margin: 16px 0 18px 0;
  background: linear-gradient(180deg, #faf9ff, #f6f4ff);
  border: 1px solid #eee9ff;
  border-radius: 12px;
  padding: 12px 14px;
}

.fnl-results {
  margin: 10px 0 8px 0;
}

.fnl-section {
  margin: 16px 0 18px 0;
  padding: 12px 14px;
  border: 1px solid #ede9ff;
  border-radius: 12px;
  background: #fbfaff;
}

.fnl-section-title {
  font-weight: 700;
  color: #2f2f33;
  margin-bottom: 12px;
  font-size: 1rem;
  letter-spacing: 0.2px;
}

.fnl-link-box {
  border: 1px solid #ececff;
  border-radius: 10px;
  padding: 10px 12px;
  max-height: 280px;
  overflow-y: auto;
  background: #ffffff;
}

.fnl-checkbox-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 0 12px 0;
  color: #2d2d2f;
  font-size: 0.95rem;
}

.fnl-checkbox-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 0;
  color: #37383d;
  font-size: 0.93rem;
  word-break: break-all;
  border-bottom: 1px dashed #efeff7;
}

.fnl-checkbox-row:last-child {
  border-bottom: none;
}

.fnl-existing-summary {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  background: #f8f6ff;
  border: 1px solid #ebe6ff;
  border-radius: 12px;
  color: #2f2a44;
  font-weight: 500;
  margin-top: 8px;
}

.fnl-existing-icon {
  color: #5616ea;
  font-size: 18px;
}

.fnl-error-summary {
  background: #fff5f5;
  border: 1px solid #ffd5d5;
  color: #c62828;
}

.add-url-button {
  transition: transform 0.08s ease;
}

.add-url-button:active {
  transform: scale(0.98);
}

.fnl-actions {
  margin-top: 22px;
}

.fnl-primary-btn {
  border-radius: 10px;
  padding: 11px 18px;
  box-shadow: 0 8px 18px rgba(94, 27, 255, 0.22);
}

.fnl-primary-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  box-shadow: none;
}

.fnl-cancel-btn {
  border-radius: 10px;
  padding: 11px 18px;
}

.remove-url-button {
  transition: opacity 0.12s ease;
}

.remove-url-button:hover {
  opacity: 0.8;
}

.fnl-exp-header {
  display: grid;
  align-items: center;
  grid-template-columns: 420px 1fr auto;
  column-gap: 12px;
  cursor: pointer;
}

.fnl-exp-header.disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.fnl-exp-left {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.fnl-exp-title {
  font-weight: 700;
  color: #2f2f33;
  font-size: 1rem;
  letter-spacing: 0.2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.fnl-exp-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.fnl-selected-count {
  font-size: 0.92rem;
  color: #4a4953;
  text-align: left;
  align-self: center;
}

.fnl-inline-action {
  border-radius: 10px;
  padding: 8px 14px;
  box-shadow: 0 6px 14px rgba(94, 27, 255, 0.18);
  justify-self: end;
}

.fnl-chevron {
  font-size: 14px;
  color: #5616ea;
}

.fnl-chevron.disabled {
  color: #9e9e9e;
}

.links-status-icon {
  color: #5616ea;
  margin-right: 0.5rem;
}

.links-status-icon.disabled {
  color: #55555a;
  margin-right: 0.5rem;
}

.links-status-icon-warning {
  color: #5616ea;
  margin-right: 0.5rem;
}

.links-status-icon-warning.disabled {
  color: #55555a;
  margin-right: 0.5rem;
}

/* ── Behavior examples (expandable, inside the Add Behavior modal) ──── */
.behavior-modal-examples {
  margin-top: 4px;
}

.behavior-modal-examples-toggle {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  color: #5616ea;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.behavior-modal-examples-chevron {
  font-size: 11px;
  transition: transform 0.2s ease;
}

.behavior-modal-examples-chevron.open {
  transform: rotate(180deg);
}

/* Smooth expand/collapse: animate the grid row from 0fr → 1fr so the panel
   slides open to its natural height without measuring it in JS. */
.behavior-modal-examples-wrap {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.28s ease;
}

.behavior-modal-examples-wrap.open {
  grid-template-rows: 1fr;
}

.behavior-modal-examples-inner {
  overflow: hidden;
  min-height: 0;
  opacity: 0;
  transition: opacity 0.28s ease;
}

.behavior-modal-examples-wrap.open .behavior-modal-examples-inner {
  opacity: 1;
}

@media (prefers-reduced-motion: reduce) {
  .behavior-modal-examples-wrap,
  .behavior-modal-examples-inner,
  .behavior-modal-examples-chevron {
    transition: none;
  }
}

.behavior-modal-examples-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  /* Padding (not margin) so the spacing collapses with the panel. */
  padding-top: 10px;
}

.behavior-modal-example {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 3px;
  text-align: left;
  padding: 10px 12px;
  background: #fbfaff;
  border: 1px solid #ece9ff;
  border-radius: 10px;
  cursor: pointer;
  font-family: inherit;
  transition: border-color 0.2s ease, background-color 0.2s ease;
}

.behavior-modal-example:hover {
  background: #f5f1ff;
  border-color: #cbb9f4;
}

.behavior-modal-example-title {
  font-size: 13px;
  font-weight: 700;
  color: #5616ea;
}

.behavior-modal-example-text {
  font-size: 13px;
  color: #3a3a44;
  line-height: 1.4;
}

@media (max-width: 600px) {
  .fnl-exp-header {
    grid-template-columns: 1fr auto;
    row-gap: 8px;
  }
  .fnl-exp-left {
    grid-column: 1 / -1;
  }
  .fnl-selected-count {
    grid-column: 1 / 2;
  }
  .fnl-inline-action {
    grid-column: 2 / 3;
    justify-self: end;
  }
  .fnl-link-box {
    max-height: 340px;
  }
  .fnl-fetch-btn {
    padding: 10px 14px;
  }
  .fnl-row {
    gap: 10px !important
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/addWebsiteLinkModal.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,qDAAqD;EACrD,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,8CAA8C;EAC9C,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA,0EAA0E;AAC1E;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;kEACkE;AAClE;EACE,aAAa;EACb,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;;;IAGE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kEAAkE;EAClE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,8DAA8D;AAChE;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,+BAA+B;IAC/B,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE;EACF;AACF","sourcesContent":[".fnl-title {\r\n  margin: 0px 0 24px 0;\r\n  font-size: 20px;\r\n  color: #2d2d2f;\r\n  letter-spacing: 0.2px;\r\n}\r\n\r\n.fnl-row {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.fnl-row .MuiOutlinedInput-root {\r\n  border-radius: 10px;\r\n}\r\n\r\n.fnl-fetch-btn {\r\n  border-radius: 10px;\r\n  padding: 11px 18px;\r\n  box-shadow: 0 6px 14px rgba(94, 27, 255, 0.18);\r\n}\r\n\r\n.fnl-spinner-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  color: #585a63;\r\n  font-size: 0.95rem;\r\n  margin: 16px 0 18px 0;\r\n  background: linear-gradient(180deg, #faf9ff, #f6f4ff);\r\n  border: 1px solid #eee9ff;\r\n  border-radius: 12px;\r\n  padding: 12px 14px;\r\n}\r\n\r\n.fnl-results {\r\n  margin: 10px 0 8px 0;\r\n}\r\n\r\n.fnl-section {\r\n  margin: 16px 0 18px 0;\r\n  padding: 12px 14px;\r\n  border: 1px solid #ede9ff;\r\n  border-radius: 12px;\r\n  background: #fbfaff;\r\n}\r\n\r\n.fnl-section-title {\r\n  font-weight: 700;\r\n  color: #2f2f33;\r\n  margin-bottom: 12px;\r\n  font-size: 1rem;\r\n  letter-spacing: 0.2px;\r\n}\r\n\r\n.fnl-link-box {\r\n  border: 1px solid #ececff;\r\n  border-radius: 10px;\r\n  padding: 10px 12px;\r\n  max-height: 280px;\r\n  overflow-y: auto;\r\n  background: #ffffff;\r\n}\r\n\r\n.fnl-checkbox-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 6px 0 12px 0;\r\n  color: #2d2d2f;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.fnl-checkbox-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 10px 0;\r\n  color: #37383d;\r\n  font-size: 0.93rem;\r\n  word-break: break-all;\r\n  border-bottom: 1px dashed #efeff7;\r\n}\r\n\r\n.fnl-checkbox-row:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.fnl-existing-summary {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding: 12px 14px;\r\n  background: #f8f6ff;\r\n  border: 1px solid #ebe6ff;\r\n  border-radius: 12px;\r\n  color: #2f2a44;\r\n  font-weight: 500;\r\n  margin-top: 8px;\r\n}\r\n\r\n.fnl-existing-icon {\r\n  color: #5616ea;\r\n  font-size: 18px;\r\n}\r\n\r\n.fnl-error-summary {\r\n  background: #fff5f5;\r\n  border: 1px solid #ffd5d5;\r\n  color: #c62828;\r\n}\r\n\r\n.add-url-button {\r\n  transition: transform 0.08s ease;\r\n}\r\n\r\n.add-url-button:active {\r\n  transform: scale(0.98);\r\n}\r\n\r\n.fnl-actions {\r\n  margin-top: 22px;\r\n}\r\n\r\n.fnl-primary-btn {\r\n  border-radius: 10px;\r\n  padding: 11px 18px;\r\n  box-shadow: 0 8px 18px rgba(94, 27, 255, 0.22);\r\n}\r\n\r\n.fnl-primary-btn:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n  box-shadow: none;\r\n}\r\n\r\n.fnl-cancel-btn {\r\n  border-radius: 10px;\r\n  padding: 11px 18px;\r\n}\r\n\r\n.remove-url-button {\r\n  transition: opacity 0.12s ease;\r\n}\r\n\r\n.remove-url-button:hover {\r\n  opacity: 0.8;\r\n}\r\n\r\n.fnl-exp-header {\r\n  display: grid;\r\n  align-items: center;\r\n  grid-template-columns: 420px 1fr auto;\r\n  column-gap: 12px;\r\n  cursor: pointer;\r\n}\r\n\r\n.fnl-exp-header.disabled {\r\n  cursor: not-allowed;\r\n  opacity: 0.6;\r\n}\r\n\r\n.fnl-exp-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  min-width: 0;\r\n}\r\n\r\n.fnl-exp-title {\r\n  font-weight: 700;\r\n  color: #2f2f33;\r\n  font-size: 1rem;\r\n  letter-spacing: 0.2px;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.fnl-exp-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.fnl-selected-count {\r\n  font-size: 0.92rem;\r\n  color: #4a4953;\r\n  text-align: left;\r\n  align-self: center;\r\n}\r\n\r\n.fnl-inline-action {\r\n  border-radius: 10px;\r\n  padding: 8px 14px;\r\n  box-shadow: 0 6px 14px rgba(94, 27, 255, 0.18);\r\n  justify-self: end;\r\n}\r\n\r\n.fnl-chevron {\r\n  font-size: 14px;\r\n  color: #5616ea;\r\n}\r\n\r\n.fnl-chevron.disabled {\r\n  color: #9e9e9e;\r\n}\r\n\r\n.links-status-icon {\r\n  color: #5616ea;\r\n  margin-right: 0.5rem;\r\n}\r\n\r\n.links-status-icon.disabled {\r\n  color: #55555a;\r\n  margin-right: 0.5rem;\r\n}\r\n\r\n.links-status-icon-warning {\r\n  color: #5616ea;\r\n  margin-right: 0.5rem;\r\n}\r\n\r\n.links-status-icon-warning.disabled {\r\n  color: #55555a;\r\n  margin-right: 0.5rem;\r\n}\r\n\r\n/* ── Behavior examples (expandable, inside the Add Behavior modal) ──── */\r\n.behavior-modal-examples {\r\n  margin-top: 4px;\r\n}\r\n\r\n.behavior-modal-examples-toggle {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  padding: 0;\r\n  background: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n  color: #5616ea;\r\n  font-family: inherit;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  text-decoration: underline;\r\n  text-underline-offset: 2px;\r\n}\r\n\r\n.behavior-modal-examples-chevron {\r\n  font-size: 11px;\r\n  transition: transform 0.2s ease;\r\n}\r\n\r\n.behavior-modal-examples-chevron.open {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n/* Smooth expand/collapse: animate the grid row from 0fr → 1fr so the panel\r\n   slides open to its natural height without measuring it in JS. */\r\n.behavior-modal-examples-wrap {\r\n  display: grid;\r\n  grid-template-rows: 0fr;\r\n  transition: grid-template-rows 0.28s ease;\r\n}\r\n\r\n.behavior-modal-examples-wrap.open {\r\n  grid-template-rows: 1fr;\r\n}\r\n\r\n.behavior-modal-examples-inner {\r\n  overflow: hidden;\r\n  min-height: 0;\r\n  opacity: 0;\r\n  transition: opacity 0.28s ease;\r\n}\r\n\r\n.behavior-modal-examples-wrap.open .behavior-modal-examples-inner {\r\n  opacity: 1;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .behavior-modal-examples-wrap,\r\n  .behavior-modal-examples-inner,\r\n  .behavior-modal-examples-chevron {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.behavior-modal-examples-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  /* Padding (not margin) so the spacing collapses with the panel. */\r\n  padding-top: 10px;\r\n}\r\n\r\n.behavior-modal-example {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  gap: 3px;\r\n  text-align: left;\r\n  padding: 10px 12px;\r\n  background: #fbfaff;\r\n  border: 1px solid #ece9ff;\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  font-family: inherit;\r\n  transition: border-color 0.2s ease, background-color 0.2s ease;\r\n}\r\n\r\n.behavior-modal-example:hover {\r\n  background: #f5f1ff;\r\n  border-color: #cbb9f4;\r\n}\r\n\r\n.behavior-modal-example-title {\r\n  font-size: 13px;\r\n  font-weight: 700;\r\n  color: #5616ea;\r\n}\r\n\r\n.behavior-modal-example-text {\r\n  font-size: 13px;\r\n  color: #3a3a44;\r\n  line-height: 1.4;\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .fnl-exp-header {\r\n    grid-template-columns: 1fr auto;\r\n    row-gap: 8px;\r\n  }\r\n  .fnl-exp-left {\r\n    grid-column: 1 / -1;\r\n  }\r\n  .fnl-selected-count {\r\n    grid-column: 1 / 2;\r\n  }\r\n  .fnl-inline-action {\r\n    grid-column: 2 / 3;\r\n    justify-self: end;\r\n  }\r\n  .fnl-link-box {\r\n    max-height: 340px;\r\n  }\r\n  .fnl-fetch-btn {\r\n    padding: 10px 14px;\r\n  }\r\n  .fnl-row {\r\n    gap: 10px !important\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
